/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [付费套餐列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42898) 的 **请求函数**
 *
 * @分类 [聊天套餐↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10001)
 * @请求头 `GET /chat/package/paid/list`
 * @更新时间 `2023-08-18 14:18:20`
 */
export const feimaChatChatPackagePaidList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatChatPackagePaidListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatChatPackagePaidListResponse, OT>
  >('/chat/package/paid/list', 'GET', data, options);

/**
 * 接口 [付费升级列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42904) 的 **请求函数**
 *
 * @分类 [聊天套餐↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10001)
 * @请求头 `GET /chat/package/upgrade/list`
 * @更新时间 `2023-08-18 14:49:01`
 */
export const feimaChatChatPackageUpgradeList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatChatPackageUpgradeListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatChatPackageUpgradeListResponse, OT>
  >('/chat/package/upgrade/list', 'GET', data, options);

/**
 * 接口 [套餐用量↗](https://yapi.fenxianglife.com/project/379/interface/api/47614) 的 **请求函数**
 *
 * @分类 [聊天套餐↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10001)
 * @请求头 `GET /chat/package/usage`
 * @更新时间 `2024-01-25 16:59:03`
 */
export const feimaChatChatPackageUsage = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatChatPackageUsageRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatChatPackageUsageResponse, OT>>(
    '/chat/package/usage',
    'GET',
    data,
    options
  );

/* prettier-ignore-end */
